((InlineCart, $) => {
  'use strict';

  /*
   *  Dependency: <div class="overlay" data-overlay></div> in theme.liquid,
   *              components/_overlay.scss
   *
   *  Note: _overlay.scss hold the styles for the overlay container
   *  Note: .overlay has a z-index of 1000, so any modal that needs to appear on top
   *        of the overlay need to have an z-index of 1001+
   *
   *
   */

  const $lineItemEntryPoint = $('[data-cart-contents]');
  const $pageLineItemEntryPoint = $('.js-cart-page-insertion');
  const $navCount = $('[data-edit="cart-count"]');
  const freeShippingAmt = window.shop.freeShippingAmt;
  const $cartBottom = $('.cart-bottom');
  const $shippingPromo = $('.shipping-promo');

  let country;

  const setCurrency = () => {
    const currency = window.GeolizrAPI.api.getCurrency();
    window.GeolizrAPI.api.switchCurrency(currency);
  };

  const pollForGeolizerApi = setInterval(() => {
    if (window.GeolizrAPI && window.GeolizrAPI.api) {
      setCurrency();
      clearInterval(pollForGeolizerApi);
    }
  }, 1000);

  const setCountry = (inputCountry) => {
    country = inputCountry;
  };

  const updatePrices = ($price) => {
    if ($price.length) {
      $price.each(() => {
        if (!$price.attr('data-price-changed')) {
          $price.attr('data-price-changed', 'true');
          window.AddTax.setPrice($price, 'data-geolizr-price');
        }
      });
    }
  };

  const resetCartButton = () => {
    if (!$shippingPromo.length) {
      $cartBottom.css('bottom', '105px');
    }
  };

  const updateShippingPromo = () => {
    const subTotalAmt = ((window.CartJS.cart.total_price / 100).toFixed(2));
    window.fleshlight.methods.cart._update_shipping_promo(subTotalAmt, freeShippingAmt);
  };

  const setCartInner = () => {
    if (window.Geolizr && window.GeolizrAPI && window.GeolizrAPI.api) {
      if (country && country.toLowerCase() === 'au') {
        const $price = $('.cart-sidecar [data-geolizr-price]');
        updatePrices($price);
      }
      setCurrency();
    }
    updateShippingPromo();
  };

  const getCartContents = () => {
    $.get('/cart?view=contents', (response) => {
      $lineItemEntryPoint.html(response);
      setCartInner();
    });

    if ($pageLineItemEntryPoint.length) {
      $.get('/cart?view=page-contents', (response) => {
        $pageLineItemEntryPoint.html(response);
        setCartInner();
      });
    }
  };

  const addToCartError = (jqXHR) => {
    window.alert('Sorry, we\'re unable to do that.\n' + JSON.parse(jqXHR.responseText).description);
  };

  const builderAddToCart = (self) => {
    const variantId = $(self).attr('data-variant-id');
    const variantQty = $(self).attr('data-variant-qty');

    let accessoryIds = $(self).attr('data-accessories-ids');

    if (accessoryIds.indexOf(',') < 0) {
      accessoryIds = accessoryIds.split();
    } else {
      accessoryIds = accessoryIds.split(',');
    }

    const selectedSteps = [];

    $.each($(':checked'), function addStep(i, val) {
        const stepVal = $(this).val();
        selectedSteps.push(stepVal);
      });

    window.CartJS.addItem(variantId, variantQty, {
      Case: selectedSteps[0],
      Orifice: selectedSteps[1],
      Texture: selectedSteps[2]
    }, {
      error: addToCartError
    });

    if (accessoryIds[0].length > 0) {
      accessoryIds.forEach((id) => {
        window.CartJS.addItem(id, 1, {}, {
          error: addToCartError
        });
      });
    }
  };

  const addLineItem = (self) => {
    const variantId = $(self).attr('data-variant-id');
    const variantQty = $(self).attr('data-variant-qty');
    const hoverText = $(self).attr('data-hover-text');
    const moreInfo = {
      Description: hoverText,
    };

    if ($(self).attr('data-disclaimer-accept')) {
      moreInfo.Disclaimer = 'I have read the instructions and precautions for this product, and agree to the terms.';
    }

    if ($('body').hasClass('product-builder')) {
      builderAddToCart(self);
    } else {
      window.CartJS.addItem(variantId, variantQty, moreInfo, {
        error: addToCartError
      });
    }
  };

  const removeLineItem = (self) => {
    const lineItem = $(self).attr('data-line-index');
    window.CartJS.removeItem(lineItem);
  };

  const triggerInlineCart = () => {
    $('body').toggleClass('cart-open');
    $('.cart-sidecar-overlay').addClass('animate-in');
  };

  const bindUIActions = () => {
    $(document).on('click', '[data-add-to-cart]', function disclamierCheck(event) {
      event.preventDefault();
      const $disclaimerSubmit = $('.js-disclaimer-agree');

      if ($(this).attr('data-disclaimer')) {
        $disclaimerSubmit.attr('data-variant-qty', $(this).attr('data-variant-qty'));
        $disclaimerSubmit.attr('data-variant-id', $(this).attr('data-variant-id'));
        $disclaimerSubmit.attr('data-hover-text', $(this).attr('data-hover-text'));
      } else {
        addLineItem(this);

        if ($('body').hasClass('page-cart')) {
          triggerInlineCart();
        }
      }
    });

    $(document).on('change', '[name="item-quantity"]', function quantityChange() {
      const QtyVarID = $(this).attr('data-variant-id');
      const QtyAmt = $(this).val();
      window.CartJS.updateItemById(QtyVarID, QtyAmt);

      if ($('body').hasClass('page-cart')) {
        const lineItemTotal = $(this).attr('data-variant-price');
        const convertedlineItem = parseFloat(lineItemTotal * QtyAmt);
        $(this).closest('.cart-item').find('.price-actual').find('[data-geolizr-price]').attr('data-geolizr-price', convertedlineItem);
        if (window.GeolizrAPI && window.GeolizrAPI.api) {
          window.GeolizrAPI.api.switchCurrency(window.GeolizrAPI.api.getCurrency());
        }
      }
    });

    $(document).on('change', '[name="quantity"]', function quantityUpdate() {
      const QtyAmt = $(this).val();
      $('.button-container .button').attr('data-variant-qty', QtyAmt);
    });

    $(document).on('click', '[data-action="cart-sidecard-remove-item"]', function removeItemFromCart() {
      removeLineItem(this);
    });

    $(document).on('click', '[data-action="cart-close"]', function closeCart() {
      window.fleshlight.methods.cart._close();
    });

    $(document).on('cart.requestComplete', (event, cart) => {
      const updateCartCount = () => {
        $navCount.text(cart.item_count);

        if ($('body').hasClass('page-cart')) {
          $('.cart-review .subtotal [data-geolizr-price]').attr('data-geolizr-price', cart.total_price);
        }
      };

      getCartContents();
      updateCartCount();
      updateShippingPromo();
    });

    $pageLineItemEntryPoint.on('click', '.cart-item-remove', function removeCartItem(event) {
      event.preventDefault();
      const lineNumber = parseInt($(this).attr('data-line-number'));
      window.CartJS.removeItem(lineNumber);
    });
  };

  const init = (country) => {
    setCountry(country);
    bindUIActions();
    getCartContents();
    resetCartButton();
  };

  InlineCart.init = init;
  InlineCart.triggerInlineCart = triggerInlineCart;
})(window.InlineCart = window.InlineCart || {}, jQuery);
